import { useMemo } from "react";

import { UseMutationOptions, UseMutationResult, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useAlert } from "capitalrx-components-2.0/lib/general";
import { useAuthToken } from "capitalrx-shell";
import { requestDiscountCardAPI } from "@/api";


interface ErrorResponse {
  readonly message?: string;
}

const createCreateOrUpdateHook = <Request, Response>(apiCall: (request: Request, authToken: string) => Promise<Response>) => {
  const useCreateOrUpdate = (options?: UseMutationOptions<Response, AxiosError, Request>) => {
    const showAlert = useAlert();
    const defaultOptions = options ? options : {};
    const [authToken] = useAuthToken();

    const mutation: UseMutationResult<Response, AxiosError, Request> = useMutation({
      mutationFn: async (request: Request) => apiCall(request, authToken),
      onError: (error: AxiosError<ErrorResponse, unknown>, _, context) => {
        showAlert({
          message: error.response?.data?.message || error.message,
          type: "error",
          style: "toast",
        });
      },
      ...defaultOptions,
    });

    return useMemo(() => mutation, [mutation, showAlert]);
  };

  return useCreateOrUpdate;
};

export const useRequestDiscountCard = createCreateOrUpdateHook(requestDiscountCardAPI);
